<template>
  <div>
    <h3>Allgemeine Gesch&auml;ftsbedingungen der LAN1 Hotspots GmbH</h3>
    <sui-list ordered>
      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Geltungsbereich</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Die vorliegenden Gesch&auml;ftsbedingungen enthalten die zwischen Ihnen und uns, der Firma LAN1 Hotspots GmbH in 22765 Hamburg, Gau&szlig;stra&szlig;e 158 ausschlie&szlig;lich geltenden Bedingungen f&uuml;r die Nutzung unserer drahtlosen Zug&auml;nge zum Internet nach WLAN-Standard (sog. Hotspots), soweit diese nicht durch schriftliche Vereinbarungen zwischen den Parteien abge&auml;ndert werden.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  &Auml;nderungen dieser Gesch&auml;ftsbedingungen werden Ihnen schriftlich, per Telefax oder per E-Mail mitgeteilt. Widersprechen Sie dieser &Auml;nderung nicht innerhalb von zwei Wochen nach Zugang der Mitteilung, gelten die &Auml;nderungen als durch Sie anerkannt. Auf das Widerspruchsrecht und die Rechtsfolgen des Schweigens werden Sie im Falle der &Auml;nderung der Gesch&auml;ftsbedingungen noch gesondert hingewiesen.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Vertragsschluss</sui-list-header>
          <sui-list-description>

            <sui-list unordered>
              <sui-list-item>
                <sui-list-content>
                  Die Pr&auml;sentation unserer Dienstleistungen stellt kein bindendes Angebot unsererseits dar. Erst die Bestellung einer Dienstleistung durch Sie ist ein bindendes Angebot nach &sect; 145 BGB.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Die Annahme Ihres Angebots kann abgelehnt werden, wenn ein sachlicher Grund vorliegt, z.B. Sie unrichtige Angaben machen, Ihren Zahlungsverpflichtungen voraussichtlich nicht nachkommen werden oder der begr&uuml;ndete Verdacht besteht, dass Sie die Leistungen missbr&auml;uchlich nutzen wollen.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Widerrufsrecht</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Sie haben ein Widerrufsrecht. Hinsichtlich der Voraussetzungen und Rechtsfolgen des Widerrufsrechts wird auf die Widerrufsbelehrung verwiesen.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Leistungen</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Wir unterst&uuml;tzen Sie als Kunden beim Zugang zum Internet zum Abruf der dort verf&uuml;gbaren Inhalte. Dazu &uuml;bernehmen wir f&uuml;r den Kunden die Vermittlung von Daten aus und zu Teilnetzen des Internets &uuml;ber das von uns betriebene Datennetz.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Unsere Leistungen beschr&auml;nken sich allein auf die Vermittlung der von Ihnen als Kunde initiierten Datenkommunikation zwischen Ihrem Anschluss und dem &Uuml;bergabepunkt an das Internet. Eine Einflussnahme auf den Datenverkehr au&szlig;erhalb des eigenen Kommunikationsnetzes ist uns als Provider nicht m&ouml;glich. Eine erfolgreiche Weiterleitung von Informationen von oder zu dem vom Kunden angesprochenen Zielrechner ist insoweit nicht geschuldet.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>


      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Verf&uuml;gbarkeit</sui-list-header>

          <sui-list ordered>
            <sui-list-item>
              <sui-list-content>
                Wir werden die Leistungen nach &sect; 4 im Rahmen der bestehenden technischen und betrieblichen M&ouml;glichkeiten anbieten. Aus technischen Gr&uuml;nden kann eine bestimmte &Uuml;bertragungsgeschwindigkeit oder eine zu jeder Zeit freie Leitung nicht garantiert werden, da dies auch von der Anzahl der Nutzer des jeweiligen Hotspots sowie von dessen atmosph&auml;rischen, baulichen und geografischen Besonderheiten abh&auml;ngig ist (z.B. Einfl&uuml;sse durch Wasserreflektionen in H&auml;fen oder durch B&auml;ume auf Campingpl&auml;tzen). Zeitweilige St&ouml;rungen, Beschr&auml;nkungen oder Unterbrechungen k&ouml;nnen sich auch aus Gr&uuml;nden h&ouml;herer Gewalt, insbesondere in Not- und Katastrophenf&auml;llen, Unterbrechungen der Stromversorgung, Streiks, Aussperrungen und beh&ouml;rdlichen Anordnungen ergeben.<br />
                Wir werden alle zumutbaren Anstrengungen unternehmen, um solche St&ouml;rungen baldm&ouml;glichst zu beseitigen bzw. auf deren Beseitigung hinzuwirken.
              </sui-list-content>
            </sui-list-item>
            <sui-list-item>
              <sui-list-content>
                Absatz 1 gilt entsprechend f&uuml;r St&ouml;rungen, Beschr&auml;nkungen oder Unterbrechungen von Telekommunikations-anlagen Dritter, die von uns zur Erf&uuml;llung der Verpflichtungen aus diesem Vertrag benutzt werden.
              </sui-list-content>
            </sui-list-item>
          </sui-list>

        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Bereitstellung der Leistungen</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Die Leistungen werden Ihnen ab Zugang der Zugangsdaten zur Verf&uuml;gung gestellt.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Die f&uuml;r die Autorisierung der Inanspruchnahme der Leistungen verwendeten Usernamen und Passw&ouml;rter haben Sie als Kunde geheim zu halten und daf&uuml;r Sorge zu tragen, dass diese Dritten nicht zug&auml;nglich sind.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Reseller-Ausschluss</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Sie d&uuml;rfen die von uns zur Verf&uuml;gung gestellten Leistungen zu gewerblichen Zwecken Dritten nicht zur Nutzung &uuml;berlassen.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>


      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Mitwirkungsleistungen und Verpflichtungen des Kunden</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Sie &uuml;bernehmen es als eigene Mitwirkungsleistung, sich mit einem geeigneten Endger&auml;t die Voraussetzungen zu schaffen, Daten mit uns als dem Provider auszutauschen. Der nach Anmeldung generierte Datenverkehr zwischen Endger&auml;t und Hotspot wird unverschl&uuml;sselt &uuml;bertragen. Eine Sicherung des Datenverkehrs innerhalb des WLAN-Systems kann erst durch Nutzung einer speziellen Sicherungssoftware durch Sie als Kunden erfolgen. Die Einzelheiten der Ihnen obliegenden erforderlichen Mitwirkungsleistungen ergeben sich aus den im Anhang aufgef&uuml;hrten Technischen Spezifikationen.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Sie verpflichten sich unsere Dienste weder zur Verbreitung noch zum Abruf rechts- und sittenwidriger Informationen im Internet noch anderweitig missbr&auml;uchlich zu nutzen. Dies gilt insbesondere in Hinblick auf die Einhaltung der gesetzlichen Bestimmungen des Jugendschutzes, die Beachtung fremder Schutzrechte (z.B. Urheberrechte, Markenrechte, Patentrechte), die Verbreitung verleumderischer, beleidigender oder volksverhetzender Inhalte oder die &Uuml;bertragung und Verbreitung von Computerviren (z.B. "Trojanische Pferde").
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Sie sind f&uuml;r die Inhalte, welche Sie &uuml;ber den Hotspot aus dem Internet abrufen oder bereitstellen selbst verantwortlich. Eine inhaltliche &Uuml;berpr&uuml;fung durch uns findet nicht statt.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Zahlungsbedingungen</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Um unsere Zugangsleistungen an den kostenpflichtigen Hotspots nutzen zu k&ouml;nnen, m&uuml;ssen Sie zun&auml;chst eine Zugangskarte (sog. VoucherCard) erwerben, welche ein bestimmtes Zeitguthaben (Zeitguthabenkarte) aufweist oder f&uuml;r einen bestimmten Zeitraum gilt (Zeitablaufkarten). Sie k&ouml;nnen die Zugangsberechtigungen f&uuml;r kostenpflichtige Hotspots auch in unserem Shop erhalten. Der Onlineerwerb f&uuml;r kostenpflichtige Hotspots ist jedoch nicht f&uuml;r alle Standorte gew&auml;hrleistet. Sie sind als Kunde insofern vorleistungspflichtig.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Hotline</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Wir stellen Ihnen zur Unterst&uuml;tzung in technischen Fragen eine Hotline zur Verf&uuml;gung, die &uuml;ber Telefon zu erreichen ist. Die Kontaktdaten kann der Kunde den Technischen Spezifikationen entnehmen.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Die Hotline dient allein Ihrer Unterst&uuml;tzung in allen mit der Inanspruchnahme unserer Leistungen zusammen-h&auml;ngenden Angelegenheiten, auf die Sie durch Einrichtung und Benutzung der Ihnen von uns &uuml;berlassenen Zugangssoftware Einfluss nehmen kann.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Kundenanfragen an die Hotline werden in der Reihenfolge ihres Einganges bearbeitet.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Haftung</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Wir haften f&uuml;r Vorsatz und grobe Fahrl&auml;ssigkeit. Ferner haften wir f&uuml;r die fahrl&auml;ssige Verletzung von Pflichten, deren Erf&uuml;llung die ordnungsgem&auml;&szlig;e Durchf&uuml;hrung des Vertrages &uuml;berhaupt erst erm&ouml;glicht, deren Verletzung die Erreichung des Vertragszwecks gef&auml;hrdet und auf deren Einhaltung Sie als Kunde regelm&auml;&szlig;ig vertrauen. Im letztgenannten Fall haften wir jedoch nur f&uuml;r den vorhersehbaren, vertragstypischen Schaden. Wir haften nicht f&uuml;r die leicht fahrl&auml;ssige Verletzung anderer als der in den vorstehenden S&auml;tzen genannten Pflichten.<br />
                  <br />
                  Die vorstehenden Haftungsausschl&uuml;sse gelten nicht bei Verletzung von Leben, K&ouml;rper und Gesundheit. Die Haftung nach Produkthaftungsgesetz bleibt unber&uuml;rt.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Die Datenkommunikation &uuml;ber das Internet kann nach dem derzeitigen Stand der Technik nicht fehlerfrei und/oder jederzeit verf&uuml;gbar gew&auml;hrleistet werden. Wir haften insoweit weder f&uuml;r die st&auml;ndige noch ununterbrochene Verf&uuml;gbarkeit unseres Online-Dienstleistungssystems.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  F&uuml;r den Verlust von Daten und/oder Programmen haften wir insoweit nicht, als der Schaden darauf beruht, dass Sie es unterlassen haben, Datensicherungen durchzuf&uuml;hren und dadurch sicherzustellen, dass verloren gegangene Daten mit vertretbarem Aufwand wiederhergestellt werden k&ouml;nnen.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Sie sind verpflichtet uns von s&auml;mtlichen Anspr&uuml;chen Dritter freizustellen, welche sich aus Verst&ouml;&szlig;en gegen die in &sect; 8 dieses Vertrages genannten Verpflichtungen ergeben.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Versto&szlig;en Sie gegen Ihre Verpflichtungen aus &sect; 8 Absatz 2 dieses Vertrages, sind wir berechtigt, alle erforderlichen Ma&szlig;nahmen zur Beseitigung der missbr&auml;uchlichen Nutzung zu ergreifen. Dies beinhaltet insbesondere die sofortige Sperrung Ihrer Zugangsberechtigung f&uuml;r die Nutzung unserer Dienste. Bei schuldhafter Pflichtverletzung haften Sie uns gegen&uuml;ber auf Schadensersatz.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Vertragslaufzeit</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Das Recht zur K&uuml;ndigung aus wichtigem Grund bleibt unber&uuml;hrt.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Jede K&uuml;ndigung bedarf der Schriftform.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Datenschutz</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Personenbezogene Daten werden entsprechend der aktuellen Fassung unserer Datenschutzerkl&auml;rung erhoben und verarbeitet. Zu diesen Daten geh&ouml;ren Name und E-Mail-Adresse des Kunden sowie im Falle der Erteilung einer Einzugserm&auml;chtigung oder der Bezahlung mit Kreditkarte auch die Angaben zu seiner Bankverbindung und Kreditkartennummer als Bestandsdaten. Ferner werden Daten &uuml;ber Beginn und Ende der Inanspruchnahme der Leistungen sowie der Eingabe der Zugangscodes zur Erfassung der Nutzung verwendet. Diese Nutzungsdaten werden nach vollst&auml;ndiger Erbringung unserer Hotspot Dienstleistungen gel&ouml;scht. Die Daten werden ausschlie&szlig;lich in dem Rechenzentrum des Providers in Hamburg verarbeitet.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Alternative Streitbeilegung in Verbrauchersachen</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  Gem&auml;&szlig; Art. 14 Abs. 1 ODR-VO weisen wir auf die Plattform der Europ&auml;ischen Kommission zur Online Streitbeilegung (OS) f&uuml;r Verbraucher hin: <a href="http://ec.europa.eu/consumers/odr/" target="_blank">http://ec.europa.eu/consumers/odr/</a>.<br />
                  Des Weiteren informieren wir Sie gem&auml;&szlig; &sect; 36 Abs. 1 Nr. 1 VSBG dar&uuml;ber, dass wir zu einer Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle nicht verpflichtet sind und hierf&uuml;r nicht zur Verf&uuml;gung stehen.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>

      <sui-list-item>
        <sui-list-content>
          <sui-list-header>Schlussbestimmungen</sui-list-header>
          <sui-list-description>

            <sui-list ordered>
              <sui-list-item>
                <sui-list-content>
                  &Auml;nderungen oder Erg&auml;nzungen dieser Gesch&auml;ftsbedingungen bed&uuml;rfen der Schriftform. Dies gilt auch f&uuml;r die Aufhebung dieses Schriftformerfordernisses.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Es gilt das Recht der Bundesrepublik Deutschland. Zwingende Bestimmungen des Staates, in dem Sie Ihren gew&ouml;hnlichen Aufenthalt haben, bleiben unber&uuml;hrt.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Sofern Sie keinen allgemeinen Gerichtsstand im Inland haben oder nach Vertragsschluss Ihren Wohnsitz ins Ausland verlegen oder Ihr Wohnsitz zum Zeitpunkt der Klageerhebung nicht bekannt ist, ist Gerichtsstand f&uuml;r alle Streitigkeiten der Sitz unseres Unternehmens in Hamburg.
                </sui-list-content>
              </sui-list-item>
              <sui-list-item>
                <sui-list-content>
                  Sollten einzelne Bestimmungen dieses Vertrages unwirksam sein oder den gesetzlichen Regelungen widersprechen, so wird hierdurch der Vertrag im &Uuml;brigen nicht ber&uuml;hrt. Die unwirksame Bestimmung wird von den Vertragsparteien einvernehmlich durch eine rechtswirksame Bestimmung ersetzt, welche dem wirtschaftlichen Sinn und Zweck der unwirksamen Bestimmung am n&auml;chsten kommt. Die vorstehende Regelung gilt entsprechend bei Regelungsl&uuml;cken.
                </sui-list-content>
              </sui-list-item>
            </sui-list>

          </sui-list-description>
        </sui-list-content>
      </sui-list-item>
    </sui-list>


    <h3>LAN1 Hotspots GmbH</h3>
    <br />
    Amtsgericht Hamburg HRB Nr. 118700<br />
    <br />
    Gau&szlig;stra&szlig;e 158<br />
    DE 22765 Hamburg<br />
    vertreten durch den Gesch&auml;ftsf&uuml;hrer: J&ouml;rg H&uuml;mmer<br />
    Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect; 27a UstG: DE277065194<br />
    Tel:  +49(0)40 - 317 66 66 0<br />
    Fax: +49(0)40 - 317 66 66 33<br />
    Email: info@lan1.de<br />
    Internet: www.lan1.de<br />
    <br />
    <span>Hamburg (08/2020)</span>
  </div>
</template>

<script>
  export default {
  }
</script>
